import URL from './url'
import http from '@/utils/httpUtils'

export default {
  // 查询选修班签到详情
  getSignClassDetail(_postData) {
    return http.get(URL.API_H5_ELECTIVE_SIGN_CLASS_DETAIL, _postData)
  },
  // 查询选修班签到情况
  getSignClassList(_postData) {
    return http.get(URL.API_H5_ELECTIVE_SIGN_CLASS_LIST, _postData)
  },
  // 查询选修班签到统计情况
  getSignClassStat(_postData) {
    return http.get(URL.API_H5_ELECTIVE_SIGN_CLASS_STAT, _postData)
  },
  // 查询所有需要签到的老师
  getSignTeacherList(_postData) {
    return http.get(URL.API_H5_ELECTIVE_SIGN_GETTEACHERLIST, _postData)
  },
  // 通知班主任
  postNoticeAdviser(_postData) {
    return http.post(URL.API_H5_ELECTIVE_SIGN_NOTICEADVISER, _postData)
  },
  // 一键签到
  signQuickly(_postData) {
    return http.post(URL.API_H5_ELECTIVE_SIGN_QUICKLY, _postData)
  },
  // 学生签到详情
  getSignStudentDetail(_postData) {
    return http.get(URL.API_H5_ELECTIVE_SIGN_STUDENT_DETAIL, _postData)
  },
  // 查询本学期选学生签到统计
  getSignStudentStat(_postData) {
    return http.get(URL.API_H5_ELECTIVE_SIGN_STUDENT_STAT, _postData)
  },
  // 更新学生签到状态
  postUpdateStatus(_postData) {
    return http.post(URL.API_H5_ELECTIVE_SIGN_UPDATESTATUS, _postData)
  },
  getNoticeDetailInfoByTaskId(_postData) {
    return http.post(URL.API_H5_TEACHER_SIGN_LIST, _postData)
  },
  // 查询行政班签到详情
  getSignInClassDetail(_postData) {
    return http.post(URL.API_COURSE_CLASS_SIGN_CLASS_DETAIL, _postData)
  },
  // 查询行政班签到情况 - 查询班级列表
  getSignInClassList(_postData) {
    return http.post(URL.API_COURSE_CLASS_SIGN_CLASS_LIST, _postData)
  },
  // 导出课表为Excel
  signInClassExport(_postData) {
    return http.post(URL.API_COURSE_CLASS_SIGN_EXPORT_CLASS_SCHEDULE, _postData)
  }
}
